// @flow

import * as React from 'react';
import moment from 'moment';
import 'moment/locale/bg';
import { injectIntl, IntlShape } from 'react-intl';

type Props = {
    value: string;
    intl: IntlShape,
};

const DateTimeColumn = (props: Props) => {
    const { value, intl: { locale }, column: { format } } = props;

    moment.locale(locale);

    return value ? moment(value).format(format || 'LLL') : null;
};

export default injectIntl(DateTimeColumn);
